jQuery(document).ready(function ($) {
  const $mobileMenuToggle = $(".mobile-menu-toggle");
  const $mobileNavigation = $(".mobile-navigation");

  // Toggle mobile menu
  $mobileMenuToggle.on("click", function () {
    $mobileNavigation.toggleClass("active");
    $mobileMenuToggle.toggleClass("active");
  });

  // Clique sur la flèche pour afficher ou masquer le sous-menu
  $(".mobile-nav-menu-principal .menu-item-has-children > a").on(
    "click",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Trouve le parent li de l'élément cliqué
      const parentLi = $(this).closest("li");

      // Affiche ou masque le sous-menu du parent li
      parentLi.children(".sub-menu").toggleClass("active");

      // Ajoute ou supprime la classe 'open' pour indiquer l'état du sous-menu
      parentLi.toggleClass("open");
    },
  );

  // Reset menu mobile au passage en desktop
  $(window).on("resize", function () {
    if ($(window).width() >= 992) {
      $mobileNavigation.removeClass("active");
      $mobileMenuToggle.removeClass("active");
    }
  });

  // Changer le texte sur le Babillard de la page d'accueil
  $(".switch-btn").on("click", function () {
    $(".switch-btn").removeClass("active");
    $(this).addClass("active");

    let target = $(this).data("target");

    $(".babillard-contenu").removeClass("active");
    $("#" + target).addClass("active");
  });
});
